import axios, { companyUrl } from './companyHttp'
import { IssueCategory, IssueStatus, IssueUser } from './issues'

export const inboxStatuses = {
  PROCESSING: 'Processing',
  RATECON: 'Rate confirmation',
  NOT_RATECON: 'Not a rate confirmation',
  NO_PDF: 'No PDF',
  COULDNT_READ: "Couldn't read",
  NOT_SAVED: 'Not saved (daily limit)',
  DISMISSED: 'Dismissed',
}
export type InboxStatus = keyof typeof inboxStatuses
export type InboxAction = 'dismiss' | 'restore' | 'ratecon' | 'retry' | 'create-issue' | 'create-job'
export type InboxIssueCategory = Exclude<IssueCategory, 'RATECON'>
export interface InboxCreateInput {
  title: string
  category: InboxIssueCategory
}
export interface InboxIssue {
  id: string
  title: string
  job: string | null
  job_number: string | null
}
export interface InboxEmail {
  id: string
  received_at: string
  sender: string
  subject: string
  status: InboxStatus
  attachment_count: number
  needs_review: boolean
  unread: boolean
  issue: string | null
  issue_title: string | null
  issue_category: IssueCategory | null
  job: string | null
  job_number: string | null
  issues: InboxIssue[]
  dismissed_at: string | null
  limited: boolean
}
export interface InboxDetail extends InboxEmail {
  preview: string
  warnings: string[]
  files: {
    id: string
    name: string
    content_type: string
    size: number
    status: Exclude<InboxStatus, 'NO_PDF' | 'NOT_SAVED' | 'DISMISSED'>
    parse_error: string
    attachment: string | null
    can_create_job?: boolean
  }[]
  actions: { id: string; kind: InboxAction; actor: IssueUser | null; date_created: string }[]
}
const endpoint = '/api/v1/inbox/'
export interface RateconAttention {
  count: number
  oldest: { id: string; received_at: string; due_at: string } | null
  server_now: string
}
export const getRateconAttention = async (): Promise<RateconAttention> =>
  (await axios.get(`${endpoint}ratecon-attention/`)).data
export const getInbox = async (
  page: number,
  status?: InboxStatus,
  unread?: boolean,
  linkedIssue?: boolean
): Promise<{
  count: number
  next: string | null
  results: InboxEmail[]
  latest_limited_received_at: string | null
}> => (await axios.get(endpoint, { params: { page, status, unread, linked_issue: linkedIssue } })).data
export interface InboxConversation {
  id: string
  subject: string
  audience: string
  issue: string
  issue_title: string
  issue_category: IssueCategory
  issue_status: IssueStatus
  message_count: number
  last_message_at: string
  last_sender: string
  last_direction: 'INBOUND' | 'OUTBOUND'
}
export const getInboxConversations = async (
  page: number
): Promise<{
  count: number
  next: string | null
  results: InboxConversation[]
}> => (await axios.get(`${endpoint}conversations/`, { params: { page } })).data
export const getInboxEmail = async (id: string): Promise<InboxDetail> =>
  (await axios.get(`${endpoint}${id}/`)).data
export const actOnInboxEmail = async (
  id: string,
  action: InboxAction,
  input: { request_key: string; file_id?: string; title?: string; category?: InboxIssueCategory }
): Promise<InboxDetail> => (await axios.post(`${endpoint}${id}/${action}/`, input)).data
export const inboxFileUrl = (email: string, file: string) =>
  companyUrl(`${endpoint}${email}/files/${file}/download/`)
